var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Header, MessagesContainer, TextContainer, WidgetContainer, processUrl, EventTypes, generateFileMsg, TextContainerProvider, Popper, ConfirmationModal, } from "wbb-chat-ui";
import { SwrKeys, useGetEvents, useSession } from "../../hooks/swr";
import { SocketProvider, } from "../../context/SocketContext/SocketContext";
import { useEffect, useReducer, useRef, useState } from "react";
import { EventService } from "../../api/eventService/EventService";
import { EVENTS_ACTIONS_TYPES, eventsReducer } from "./eventsReducer";
import { Senders, generateChoiceMsg, formatAttachmentToSent, generateTextMsg, processSessionEvents, formatStringToSent, formatEvent, useLanguageContext, OverlapProvider, OverlapComponentTypes, } from "wbb-chat-ui";
import { getHeaderProps } from "./utils";
import usePersistentMenu from "../../hooks/swr/usePersistentMenu";
import { UserService } from "../../api/userService/UserService";
import ObjectID from "bson-objectid";
import { ConversationService } from "../../api/conversationService/ConversationService";
import { FeedbackService, } from "../../api/feedbackService/FeedbackService";
import useHeaderInfo from "../../hooks/swr/useHeaderInfo";
import { useSWRConfig } from "swr";
import { SessionService } from "../../api/sessionService";
import { useIdle } from "../../hooks/useIdle";
import { DEFAULT_SESSION_IDLE_MESSAGE, DEFAULT_SESSION_IDLE_MODAL_TIMEOUT, DEFAULT_SESSION_IDLE_TIMEOUT, DEFAULT_SESSION_IDLE_TITLE, } from "./defaults";
import FocusLock from "react-focus-lock";
import { TranscriptionService } from "../../api/transcriptionService/TranscriptionService";
import { BrowserEventService, EventName, } from "../../api/BrowserEventService/BrowserEventService";
var INIT = EVENTS_ACTIONS_TYPES.INIT, UPDATE = EVENTS_ACTIONS_TYPES.UPDATE;
function Chat(_a) {
    var initialSession = _a.initialSession, open = _a.open, typingIndicator = _a.typingIndicator, botIcon = _a.botIcon, chatSessionSettings = _a.chatSessionSettings, logicdialogPreview = _a.logicdialogPreview, companyName = _a.companyName, onToggle = _a.onToggle, closeChat = _a.closeChat;
    var operator = Senders.USER;
    var setLanguage = useLanguageContext().setLanguage;
    var mutate = useSWRConfig().mutate;
    var _b = useSession(initialSession, true), session = _b.session, error = _b.error, isValidating = _b.isValidating;
    var persistentMenu = usePersistentMenu(initialSession, open).persistentMenu;
    var headerInfo = useHeaderInfo(session).headerInfo;
    var _c = useReducer(eventsReducer, {}), events = _c[0], dispatch = _c[1];
    var _d = getHeaderProps(headerInfo), title = _d.title, subtitle = _d.subtitle, companyLogo = _d.companyLogo;
    var textAreaRef = useRef(null);
    var chatContainerRef = useRef(null);
    var msgsContainerRef = useRef(null);
    var _e = useState(null), overlapComponentType = _e[0], setOverlapComponentType = _e[1];
    var _f = useState(null), overlapProps = _f[0], setOverlapProps = _f[1];
    var chatInitialized = useRef(false);
    var _g = useGetEvents(initialSession, open), data = _g.data, eventsError = _g.error, eventsAreLoading = _g.isLoading;
    useEffect(function () {
        if ((session === null || session === void 0 ? void 0 : session.userSid) && open && !chatInitialized.current) {
            chatInitialized.current = true;
        }
    }, [session, open]);
    useEffect(function () {
        if (setLanguage && (session === null || session === void 0 ? void 0 : session.language)) {
            setLanguage(session.language);
        }
    }, [session === null || session === void 0 ? void 0 : session.language]);
    useEffect(function () {
        if (Array.isArray(data)) {
            var events_1 = processSessionEvents(data, operator);
            dispatch({
                type: INIT,
                events: events_1,
            });
        }
        else if (data === null || data === void 0 ? void 0 : data.token) {
            window.localStorage["wbb-token"] = data === null || data === void 0 ? void 0 : data.token;
        }
    }, [data]);
    useEffect(function () {
        return function () {
            chatInitialized.current = false;
            window.localStorage.removeItem("wbb-token");
        };
    }, []);
    BrowserEventService.subscribeToEvent(EventName.CLOSE_CHAT, function (event) {
        if (event.detail.resetStart) {
            delete window.logicDialogParams.startBlock;
        }
        BrowserEventService.createEvent(EventName.TOGGLE_CHAT, {
            open: false,
            userId: session === null || session === void 0 ? void 0 : session.userId,
            language: session === null || session === void 0 ? void 0 : session.language,
            domainHref: window.location.href,
            client: session === null || session === void 0 ? void 0 : session.client,
        });
        endChat();
    });
    BrowserEventService.subscribeToEvent(EventName.SEND_MESSAGE, function (event) {
        handleSendMgs(event.detail.message);
    });
    function endChat() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!session) return [3 /*break*/, 3];
                        return [4 /*yield*/, EventService.postEndConversations(session)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, SessionService.endSession(session)];
                    case 2:
                        _a.sent();
                        closeChat();
                        // reset Session, start conversation and get events
                        mutate(SwrKeys.SESSION, __assign(__assign({}, initialSession), { newSession: true }), true);
                        mutate(SwrKeys.START_CHAT, undefined);
                        mutate(SwrKeys.EVENTS, undefined);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var timeout = (chatSessionSettings === null || chatSessionSettings === void 0 ? void 0 : chatSessionSettings.timeout) || DEFAULT_SESSION_IDLE_TIMEOUT;
    var confirmationTimeout = (chatSessionSettings === null || chatSessionSettings === void 0 ? void 0 : chatSessionSettings.confirmationTimeout) ||
        DEFAULT_SESSION_IDLE_MODAL_TIMEOUT;
    var enableSessionTimeout = (chatSessionSettings === null || chatSessionSettings === void 0 ? void 0 : chatSessionSettings.enableSessionTimeout) || false;
    var _h = useIdle({
        enableSessionTimeout: open && enableSessionTimeout,
        timeout: timeout,
        confirmationTimeout: confirmationTimeout,
        endChat: endChat,
    }), openPrompt = _h.openPrompt, handleStillHere = _h.handleStillHere;
    function postTextMsg(message) {
        EventService.postTextEvent(message);
    }
    function postChoiceMsg(message) {
        EventService.postChoiceEvent(message);
    }
    function postFileMsg(message) {
        EventService.postFileEvent(message);
    }
    function postFileForm(message) {
        return EventService.postFileForm(message);
    }
    function addNewTextEvent(text, eventId) {
        dispatch({
            type: UPDATE,
            events: formatStringToSent(text, eventId, operator),
        });
    }
    function addNewAttachmentEvent(blob, eventId, url) {
        dispatch({
            type: UPDATE,
            events: formatAttachmentToSent(blob, eventId, operator, url),
        });
    }
    function handleSendMgs(text) {
        if (session) {
            var message = generateTextMsg(session, text);
            postTextMsg(message);
            addNewTextEvent(message.text, message.eventId);
        }
    }
    function handleSendAttachment(file, url) {
        if (session) {
            var message = generateFileMsg(session, file);
            postFileMsg(message);
            if (typeof url === "string")
                addNewAttachmentEvent(file, message.eventId, url);
        }
    }
    function handleSendFormAttachment(file, url, formId) {
        if (session) {
            var message = generateFileMsg(session, file);
            postFileForm(__assign(__assign({}, message), { formId: formId }))
                .catch(function (error) {
                console.error("Failed to post file form:", error);
            });
        }
    }
    function urlChoice(choice) {
        if (choice.action.type === "url") {
            var _a = processUrl(choice.action.value), url = _a.url, target = _a.target;
            window.open(url, target);
            if (choice.next) {
                // has next block
                blockChoice(choice);
            }
        }
    }
    function blockChoice(choice) {
        if (session) {
            var message = generateChoiceMsg(session, choice);
            postChoiceMsg(message);
            addNewTextEvent(choice.selectedTitle, message.eventId);
        }
    }
    function downloadChat() {
        var token = window.localStorage["wbb-token"];
        ConversationService.downloadConversation(session.userId, session.client, token);
    }
    function handleSendChoiceMgs(choice) {
        var action = choice.action;
        if (action.type === "url") {
            if ((action === null || action === void 0 ? void 0 : action.view) === "extension") {
                var url = action.value;
                if (url.indexOf("?") < 0) {
                    url = "".concat(url, "?");
                }
                else {
                    url = "".concat(url, "&");
                }
                setOverlapComponentType(OverlapComponentTypes.Iframe);
                var token = window.localStorage["wbb-token"];
                setOverlapProps({
                    canGoBack: !!action.allowClose, // This will convert `undefined`, `null`, or `false` to `false`
                    src: "".concat(url, "client=").concat(session === null || session === void 0 ? void 0 : session.client, "&token=").concat(token),
                });
            }
            else {
                urlChoice(choice);
            }
        }
        if (action.type === "block") {
            blockChoice(choice);
        }
        if (action.type === "map" && choice.metadata) {
            setOverlapComponentType(OverlapComponentTypes.LocationForm);
            setOverlapProps(choice.metadata);
        }
        if (action.type === "file" && choice.metadata) {
            setOverlapComponentType(OverlapComponentTypes.UploadFile);
            setOverlapProps(__assign(__assign({}, choice.metadata), { onAttachFile: handleSendFormAttachment }));
        }
    }
    function handlePostFeedback(data) {
        FeedbackService.postFeedback(__assign(__assign({}, data), { client: session.client }));
    }
    function dispatchWbbEvent(event) {
        var formatted = formatEvent(event, operator);
        if (event.type === EventTypes.CLOSE_EXTENSION) {
            handleClosOverlap();
        }
        if ([
            EventTypes.AGENT_INTERVENTION,
            EventTypes.USER_INTERVENTION,
            EventTypes.INTERVENTION_END,
        ].includes(event.type)) {
            mutate(SwrKeys.HEADER_INFO);
        }
        if (formatted) {
            dispatch({
                type: UPDATE,
                events: formatted,
            });
        }
    }
    function sendCustomerTyping(sender) {
        if (typingIndicator) {
            UserService.getTyping({
                userId: sender,
                senderId: session.userId,
                client: session.client,
            });
        }
    }
    function dispatchTypingEvent(event) {
        if (typingIndicator) {
            var formatted = formatEvent(__assign(__assign({}, event), { _id: new ObjectID() }), Senders.AGENT);
            if (formatted) {
                dispatch({
                    type: UPDATE,
                    events: formatted,
                });
            }
        }
    }
    function handleClosOverlap() {
        setOverlapComponentType(null);
        setOverlapProps(null);
    }
    return (_jsx(FocusLock, { disabled: logicdialogPreview, children: _jsxs(WidgetContainer, { open: open, refProp: chatContainerRef, children: [_jsx(Header, { title: title, subtitle: subtitle, companyLogo: companyLogo, open: open, onToggle: onToggle, onClickDownloadChat: downloadChat, onClickEndChat: endChat, companyName: companyName }), error && (_jsx("div", { children: "There is a problem with your session, try refresh the page." })), !isValidating && chatInitialized.current && (_jsx(SocketProvider, { userSid: (session === null || session === void 0 ? void 0 : session.userSid) || "", dispatchWbbEvent: dispatchWbbEvent, dispatchTypingEvent: dispatchTypingEvent, children: _jsx(OverlapProvider, { componentTypeProp: overlapComponentType, propsProp: overlapProps, onClose: handleClosOverlap, sendMessage: handleSendMgs, headerHeight: 52, children: _jsxs(_Fragment, { children: [_jsx(MessagesContainer, { error: eventsError, isLoading: eventsAreLoading, events: events, handleSendChoice: handleSendChoiceMgs, operator: Senders.USER, botAvatar: botIcon || "", textAreaRef: textAreaRef, postFeedback: handlePostFeedback, typingAvatar: (headerInfo === null || headerInfo === void 0 ? void 0 : headerInfo.typingAvatar) || "", closeChat: closeChat, msgsContainerRef: msgsContainerRef, headerHeight: 52, footerHeight: 54 }), _jsx(TextContainerProvider, { onAttachFile: handleSendAttachment, textAreaRef: textAreaRef, persistentMenu: persistentMenu, onClickPersistentMenuItem: handleSendChoiceMgs, chatContainerRef: chatContainerRef, postTranscription: TranscriptionService.postTranscription, client: session === null || session === void 0 ? void 0 : session.client, msgsContainerRef: msgsContainerRef, children: _jsx(TextContainer, { onSend: handleSendMgs, operatorTyping: sendCustomerTyping }) })] }) }) })), chatSessionSettings && openPrompt && (_jsx(Popper, { titleId: "wbb-session-idle-modal", content: _jsx(ConfirmationModal, { titleId: "wbb-session-idle-modal", title: chatSessionSettings === null || chatSessionSettings === void 0 ? void 0 : chatSessionSettings.confirmationTitle, text: chatSessionSettings === null || chatSessionSettings === void 0 ? void 0 : chatSessionSettings.confirmationMessage, defaultTitle: DEFAULT_SESSION_IDLE_TITLE, defaultText: DEFAULT_SESSION_IDLE_MESSAGE, submitText: "Continue", cancelText: "Close", onCancel: endChat, onContinue: handleStillHere }) }))] }) }));
}
export default Chat;
